import type { ArtifactMention } from '../types.ts';
import { Highlight } from './Highlight.tsx';
import { SourceChip } from './SourceChip.tsx';

/**
 * Mention quotes as blockquotes with source links (spec: cell expansion + not-compared list).
 * `highlightQuery` is optional so every other call site is unaffected — only the filtered
 * views (v1.1) pass the active search term.
 *
 * A quote from outside the vendor's own site is marked next to its link, where the reader is
 * already looking to decide whether to believe it.
 */
export function MentionList({
  mentions,
  highlightQuery = '',
}: {
  mentions: ArtifactMention[];
  highlightQuery?: string;
}): JSX.Element {
  if (!mentions.length) return <p className="muted">no mentions</p>;
  return (
    <div className="mention-list">
      {mentions.map((m, i) => (
        <div key={i} className="mention">
          {m.description ? (
            <blockquote>
              <Highlight text={m.description} query={highlightQuery} />
            </blockquote>
          ) : (
            <p className="muted">(named, not described)</p>
          )}
          <div className="mention-source-row">
            <a href={m.url} target="_blank" rel="noreferrer">
              {m.url}
            </a>
            <SourceChip thirdParty={m.third_party} sourceKind={m.source_kind} />
          </div>
        </div>
      ))}
    </div>
  );
}
